// SYN-2757 — validade (`exp`) de um JWT, em ms. Só lê o payload: quem valida a
// assinatura é o backend. Token malformado → null (nada a renovar).
// Reads a JWT's `exp` claim (ms) without verifying it; null when unreadable.
export function tokenExpiresAt(token) {
    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const exp = JSON.parse(atob(payload)).exp;
        return Number.isFinite(exp) ? exp * 1000 : null;
    } catch (_) {
        return null;
    }
}
